/* eslint-disable react/no-children-prop */
import {
  Card,
  CardContent,
  CardMedia,
  Grid,
  makeStyles,
  Paper,
  Typography
} from "@material-ui/core";
import { isEmpty as _isEmpty } from "lodash";
import React from "react";
import ReactPlayer from "react-player";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import ReactMarkdown from "react-markdown";
import { Flaticon, SponsorList } from "../../components";
import { useCongress, useCongressStyle, useUserMe } from "../../hooks";
import GetAvailableLinks from "../lib/getAvailableLinks";
import { ReactComponent as BadgeScanSvg } from "../../assets/icons/badge scan.svg";

const useStyles = makeStyles(theme => ({
  item: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    padding: theme.spacing(3)
  },
  card: {
    width: "100%"
  },
  containerDiv: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "90%",
    padding: "0 5rem"
  },
  imageIcon: {
    height: "100%",
    width: "100%"
  },
  iconRoot: {
    textAlign: "center",
    fontSize: "8rem"
  },
  icon: {
    width: theme.spacing(10),
    height: theme.spacing(10),
    margin: theme.spacing(4),
    fill: theme.palette.primary.main
  },
  primaryColor: {
    filter:
      "brightness(0) saturate(100%) invert(16%) sepia(83%) saturate(1101%) hue-rotate(194deg) brightness(98%) contrast(87%)"
  }
}));

export default function HomePage() {
  const classes = useStyles();
  const history = useHistory();
  const { congress } = useCongress();
  const { user } = useUserMe();
  const intl = useIntl();
  const extraLinks = [];
  if (user?.hasRoles(["assistant"])) {
    extraLinks.push({
      label: intl.formatMessage({ id: "Pages.HomePage.BadgeScan", defaultMessage: "Badge Scan" }),
      icon: BadgeScanSvg,
      route: "/physical_rooms",
      featureName: "my_badge"
    });
  }

  const links = GetAvailableLinks(extraLinks);
  const congressClasses = useCongressStyle()();

  const onRouteClick =
    ({ route }) =>
    () => {
      history.push(route);
    };

  return (
    <div className={classes.containerDiv}>
      <Grid container justifyContent="center" spacing={3}>
        {(!_isEmpty(congress.welcomeVideoUrl) || !_isEmpty(congress.welcomeBody)) && (
          <Grid item md={8} xs={12} style={{ paddingLeft: 0 }}>
            <Card elevation={0} className={`${classes.item} ${classes.card}`}>
              <CardContent className={classes.card}>
                {!_isEmpty(congress.welcomeVideoUrl) && (
                  <CardMedia
                    className={classes.media}
                    title="Welcome Video"
                    component={ReactPlayer}
                    width="100%"
                    url={congress.welcomeVideoUrl}
                    controls
                  />
                )}

                {!_isEmpty(congress.welcomeBody) && (
                  <div style={{ paddingTop: 10 }}>
                    <Typography gutterBottom variant="h5" component="h2">
                      {congress.welcomeTitle}
                    </Typography>
                    <ReactMarkdown children={congress.welcomeBody} />
                  </div>
                )}
              </CardContent>
            </Card>
          </Grid>
        )}

        <Grid item container md={4} xs={12} spacing={3}>
          {links.map(({ label, icon: Icon, route }) => (
            <Grid item key={route} xs={12} style={{ paddingRight: 0 }}>
              <Paper
                elevation={0}
                onClick={onRouteClick({ route })}
                className={`${classes.item} ${congressClasses.congress}`}
              >
                {typeof Icon === "string" ? (
                  <Flaticon icon={Icon} fontSize="3rem" color="primary" margin={4} />
                ) : (
                  <Icon className={classes.icon} />
                )}
                <Typography variant="h4" align="center">
                  <strong>{label}</strong>
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
        {congress.enableFeatureSponsor && (
          <Grid item xs={12}>
            <SponsorList />
          </Grid>
        )}
      </Grid>
    </div>
  );
}
